import { gsap, ScrollTrigger } from "gsap/all";

export function scale() {
  gsap.registerPlugin(ScrollTrigger);

  // Reset animations delay & stagger inside each block
  const blocks = document.querySelectorAll(".gutenberg-content > .gutenberg-block");

  blocks.forEach((block) => {
    const animationDuration = 0.8;
    const staggerDelay = 0.08;
    const startPosition = "top 80%";
    const ease = "power2.inOut";

    const scaleXElements = block.querySelectorAll(".animation-scale-x");

    scaleXElements.forEach((element, index) => {
      const dataTrigger = element.dataset.trigger;
      const trigger = (dataTrigger ? element.closest(dataTrigger) : null) ||
                      element.closest(".animation-trigger") ||
                      element;

      gsap.from(element, {
        scaleX: 0,
        duration: animationDuration,
        delay: index * staggerDelay,
        ease: ease,
        scrollTrigger: {
          trigger: trigger,
          start: startPosition,
          // markers: true,
        },
      });
    });
  });
}